import { H2 } from "components/ui/typography/titles/Titles"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { useNavigate } from "react-router-dom"
import style from "./EmailSent.module.scss"

const { emailSent, title, text } = style

export const EmailSent = ({ email }: { email: string }) => {
	const navigate = useNavigate()

	return (
		<div className={emailSent}>
			<H2 className={title}>Email on the way!</H2>
			<p className={text}>
				We’ve sent password reset instructions to {email || "your email address"}. Follow the instructions in the email
				to reset your password.
			</p>
			<ButtonPrimary onClick={() => navigate("/")}>Continue</ButtonPrimary>
		</div>
	)
}
